<template lang="pug">
  div
    b-img(:src="alang('section2.event')" fluid)
  </div>
</template>

<script>
import util from '@/common/lang/util'
export default {
  name: 'Section2Widget',
  mixins: [util],
}
</script>

